import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, List, ListItem, ListItemText, Paper } from "@mui/material";
import { mockSendHistory as initialMockData } from "../../utils/willsmock";
import { Container } from "./WillsTestamentsContainer.styles"

export default function LawyerSendFormContainer() {
  const [email, setEmail] = useState("");
  const [sendHistory, setSendHistory] = useState([]);

  useEffect(() => {
    // Load mock send history
    setSendHistory(initialMockData);
  }, []);

  const handleSendForm = () => {
    if (!email) return alert("Please enter an email");

    const newEntry = {
      id: sendHistory.length + 1,
      email,
      status: "Sent",
      sentAt: new Date().toISOString(),
    };

    setSendHistory([newEntry, ...sendHistory]);
    setEmail("");
    alert(`Form sent to ${newEntry.email}`);
  };

  return (
    <Container>
      <Paper elevation={3} sx={{ padding: 4 }}>
        <Typography variant="h5" gutterBottom>
          Send Will Form
        </Typography>

        <TextField
          label="Client Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          sx={{ marginBottom: 2 }}
        />

        <Button variant="contained" color="secondary" onClick={handleSendForm}>
          Send Form
        </Button>

        <Typography variant="h6" sx={{ marginTop: 4 }}>
          Send History
        </Typography>

        <List>
          {sendHistory.map((entry) => (
            <ListItem key={entry.id} divider>
              <ListItemText
                primary={entry.email}
                secondary={`Status: ${entry.status} | Sent At: ${new Date(entry.sentAt).toLocaleString()}`}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
}
